import { EditingInputOnClick } from 'components/EditingInput'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import React, { CSSProperties } from 'react'
import { KVCameraView, RolodexEntryPatchJson } from 'types'

export const CameraViewNotesInput: React.FC<{
  selectedCameraView: KVCameraView
}> = ({ selectedCameraView }) => {
  const { rolodexPatch } = useRolodexEdit()
  const { kestrelModel, cameraViews, setCameraViews } = useKestrel()

  const setNotes = async (s: string) => {
    if (!cameraViews || !kestrelModel?.id) return

    // Update local state
    const updatedCameraViews = cameraViews.map((cv) =>
      cv.id === selectedCameraView.id ? { ...cv, notes: s } : cv
    )
    setCameraViews(updatedCameraViews)

    // Update rolodex
    const patchData: RolodexEntryPatchJson = {
      id: kestrelModel.id,
      data: {
        cameraViews: updatedCameraViews.map((cv) => KVCameraView.toJSON(cv)),
      },
    }

    try {
      await rolodexPatch([patchData])
    } catch (error) {
      console.error('Failed to update camera view:', error)
    }
  }

  const divStyles = {
    border: '1px solid rgba(255, 255, 255, 0.3)',
    padding: '4px',
    minHeight: '44px',
    cursor: 'text',
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
  } as CSSProperties

  const inputStyles = {
    minHeight: '44px',
    padding: '4px',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'white',
    width: '100%',
  } as CSSProperties

  return (
    <EditingInputOnClick
      divStyle={divStyles}
      inputStyle={inputStyles}
      value={selectedCameraView.notes}
      setValue={(s) => setNotes(s)}
      debugDisableBlur={true} // Prevent closing on Enter
    />
  )
}
